<div class="container">
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0" style="color: rgb(0,0,0);">Reportes Conciliacion Extracto Recaudo</h5>
    </div>
    <div class="card-body" style="color: rgb(0,0,0);">
      <p class="card-text" style="color: rgb(0,0,0);font-size: 18px;">Seleccione el rango de fecha</p>
      <form role="form" [formGroup]="formulario">
        <div class="form-group">
          <div class="row justify-content-center">
            <div class="col-md-3">
              <app-lfsa-combo-box [claseLabel]="'letrasDanger'"
                                  [comboBox]="centers"
                                  [control]="formulario.get('division')"
                                  [idOpcion]="'idCentro'"
                                  [opcion]="'nombreCentro'"
                                  [id]="'division'"
                                  [label]="'Division*'"
                                  formControlName="division">
              </app-lfsa-combo-box>
            </div>
            <div class="col-md-3">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [claseLabel]="'letrasDanger'"
                              [control]="formulario.get('fechadesde')" [placeholder]="'Fecha desde'"
                              [label]="'Fecha desde'" [type]="'date'"
                              [id]="'fechadesde'" formControlName="fechadesde" (input)="validforms()">
              </app-lfsa-input>
            </div>
            <div class="col-md-3">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [claseLabel]="'letrasDanger'"
                              [control]="formulario.get('fechahasta')" [placeholder]="'Fecha hasta'"
                              [label]="'Fecha hasta'" [type]="'date'"
                              [id]="'fechahasta'" formControlName="fechahasta" (input)="validforms()">
              </app-lfsa-input>
            </div>
          </div>

          <div class="row justify-content-center" style="margin-top: 10px;">
            <div class="col-md-3">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [claseLabel]="'letrasDefault'"
                              [control]="formulario.get('fechasapdesde')" [placeholder]="'Fecha SAP desde'"
                              [label]="'Fecha SAP desde'" [type]="'date'"
                              [id]="'fechasapdesde'" formControlName="fechasapdesde">
              </app-lfsa-input>
            </div>
            <div class="col-md-3">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [claseLabel]="'letrasDefault'"
                              [control]="formulario.get('fechasaphasta')" [placeholder]="'Fecha SAP hasta'"
                              [label]="'Fecha SAP hasta'" [type]="'date'"
                              [id]="'fechasaphasta'" formControlName="fechasaphasta">
              </app-lfsa-input>
            </div>
            <div class="col-md-3 ">
              
            </div>
          </div>

          <div class="row justify-content-center" style="margin-top: 10px;">
            <div class="col-md-3">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [claseLabel]="'letrasDefault'"
                              [control]="formulario.get('idCliente')" [placeholder]="'Id cliente'"
                              [label]="'Cod. Cliente'" [type]="'text'"
                              [id]="'idCliente'" formControlName="idCliente">
              </app-lfsa-input>
            </div>
            <div class="col-md-3">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [claseLabel]="'letrasDefault'"
                              [control]="formulario.get('idRecaudador')" [placeholder]="'Id Recaudador'"
                              [label]="'Cod. Recaudador'" [type]="'text'"
                              [id]="'idRecaudador'" formControlName="idRecaudador">
              </app-lfsa-input>
            </div>
            <div class="col-md-3 ">
              <app-lfsa-combo-box [claseLabel]="'letrasDefault'"
                                  [comboBox]="cmbEstados"
                                  [control]="formulario.get('estadoSync')"
                                  [idOpcion]="'codigo'"
                                  [opcion]="'display'"
                                  [id]="'estadoSync'"
                                  [label]="'Estado'"
                                  formControlName="estadoSync">
              </app-lfsa-combo-box>
            </div>
          </div>
          <div class="row justify-content-center" style="margin-top: 10px;">
            <div class="col-md-3 ">
              <button type="button" class="btn btn-outline-primary btn-block" (click)="callReporteMDI()" [disabled]="formulario.invalid">
                <i class="fas fa-search"></i> Buscar
              </button>
            </div>
            <div class="col-md-3 ">
              <button type="button" class="btn btn-outline-secondary btn-block" (click)="LimpiarFormulario()">
                <i class="fas fa-eraser"></i> Limpiar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>



<div class="container" style="padding-top: 13px;" >
  <div class="card" style="color: rgb(4,4,4);"  >
    <div class="card-header">
      <h5 class="mb-0">Detalle Reporte</h5>
    </div>
    <div class="card-body">
      <div class="d-flex flex-row-reverse">
        <!--<button (click)="exportAsExcel()" class="btn btn-success">Exportar</button>-->
        <button (click)="exportAsExcel()"  class="btn btn-success" type="button" style="text-align: right;"><svg class="bi bi-filetype-xls" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM6.472 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .254.384c.07.049.154.087.25.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.625.625 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94l1.274-2.007Zm2.727 3.325H4.557v-3.325h-.79v4h2.487v-.675Z"></path>
        </svg>Descarga .XLS</button>
      </div>
      <ng-container *ngIf="(this.dataSourceKardex$| async) as responsek">
        <ag-grid-angular
          style="width: 100%; height:500px;"
          class="ag-theme-alpine"
          [rowData]="responsek.respuesta"
          [columnDefs]="columnDefsConciliacion"
          (gridReady)="onGridReadyk($event)"
          [pagination]="true"
          [suppressAutoSize]="true"
          [alwaysShowHorizontalScroll]="true"
          [paginationPageSize]="moduloConciliacion.agGrid.paginacion"
          [localeText]="l10nAgGrid"
          [enableCellTextSelection]="true">
        </ag-grid-angular>
      </ng-container>
    </div>
  </div>
</div>

<!------------->
<div class="row">
  <div class="col-6 col-lg-4 col-xl-9 offset-lg-2 offset-xl-3">
    <div class="table-responsive-lg mt-4" *ngIf="totals">
      <table class="table table-striped table-responsive">
        <tbody>
          <tr>
            <td>Transferencias:</td>
            <td>{{totals.transfer_valor | currency:'es-AR':'USD'}}</td>
            <td>#Transferencias:</td>
            <td>{{totals.transfer_num}}</td>
          </tr>
          <tr>
            <td>Depósitos:</td>
            <td>{{totals.deposito_valor | currency:'es-AR':'USD'}}</td>
            <td>#Depósitos:</td>
            <td>{{totals.deposito_num}}</td>
          </tr>
          <tr>
            <td>Tot.Recaudación:</td>
            <td>{{totals.total_valor | currency:'es-AR':'USD'}}</td>
            <td>#Recaudos:</td>
            <td>{{totals.total_num}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<!------------->

